import { Box, Button } from "@mui/material";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";

const AddRowButton = ({ data, handleAddRow }) => {
  const addRowOptions = [
    { key: "1x", value: 1 },
    { key: "5x", value: 5 },
    { key: "10x", value: 10 },
    { key: "15x", value: 15 },
    { key: "20x", value: 20 },
  ];

  return (
    <>
      {data?.component?.options?.mode === "DEFAULT" &&
        data?.component?.options?.enableRowAdd && (
          <Box
            sx={{
              border: "1px solid #42a5f5",
              width: 200,
              display: "flex",
              alignItems: "center",
              height: 40
            }}
          >
            <Button
              startIcon={<AddCircleOutlinedIcon />}
              id={`${data?.component?.sName}-addrowbutton`}
              sx={{ border: "none", "&:hover": { border: "none" } }}
              variant="outlined"
              onClick={handleAddRow}
            >
              Add Row
            </Button>

            <select
              id={`${data?.component?.sName}-addrow`}
              style={{ border: "none", outline: "none" }}
              onChange={handleAddRow}
            >
              <option></option>
              {addRowOptions?.map(({ key, value }, index) => (
                <option
                  key={index}
                  value={value}
                  id={`${data?.component?.sName}-addrow${key}`}
                >
                  {key}
                </option>
              ))}
            </select>
          </Box>
        )}
    </>
  );
};

export default AddRowButton;
